import { render, staticRenderFns } from "./ServiceClients.vue?vue&type=template&id=2d6bd3a0&scoped=true&"
import script from "./ServiceClients.vue?vue&type=script&lang=ts&"
export * from "./ServiceClients.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceClients.vue?vue&type=style&index=0&id=2d6bd3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bd3a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VIcon,VTextField})
